import React from "react";
import PropTypes from "prop-types";
import { comma, commaToFixed } from "../../helpers/common.functions";
import { translate } from "../../utils/translation";
import {
  getEstimateDisplayTotal,
  hasTaxInclusiveTotal,
} from "../../helpers/costPlanningTotals.functions";
import "./EstimatesTPI.css";

export default function EstimatesTPIAnticipatedCost(props) {
  // Props
  const { estimate, project } = props;
  const { futureYear, inflation } = props;
  const { containerType, descriptionType } = props;
  const { isBreakdown } = props;
  const { isDisabled = false } = props;

  let containerTypeTotal = isBreakdown
    ? "estimates-breakdown-TPI-container-total"
    : "estimates-TPI-container-total";

  let totalCost = getEstimateDisplayTotal(estimate);
  const label = hasTaxInclusiveTotal([estimate])
    ? "Total Anticipated Cost (Incl. Tax)"
    : "Total Anticipated Cost (Excl. Tax)";

  let inflatedCostPerM2 = Math.round(
    (totalCost + inflation) / estimate.local_region_area,
  );

  let totalCostPlusInflation = parseInt(Math.round(totalCost + inflation));

  const isRegionAreaZero = estimate.local_region_area === 0;

  return (
    <div className="estimates-TPI-row">
      <div className={isRegionAreaZero ? containerType : containerTypeTotal}>
        <div className={descriptionType}>
          <div
            className={`estimates-TPI-label ${isDisabled ? "disabled" : ""}`}
          >
            <b>{translate(label)}</b>
            {isDisabled ? (
              <></>
            ) : (
              <>
                &nbsp;@ <b>{futureYear}</b>
              </>
            )}
          </div>
        </div>
        <div className="estimates-TPI-value">
          {isRegionAreaZero ? (
            <></>
          ) : (
            <b>{comma(estimate.local_region_area)}</b>
          )}
        </div>
        <div className="estimates-TPI-unit">
          {isRegionAreaZero ? <></> : <b>{project.unit_of_measure}</b>}
        </div>
        <div className="estimates-TPI-construction-cost">
          {isRegionAreaZero ? <></> : <b>{commaToFixed(inflatedCostPerM2)}</b>}
        </div>

        <div className="estimates-TPI-total">
          {isDisabled ? <></> : <b>{comma(totalCostPlusInflation)}</b>}
        </div>
      </div>
    </div>
  );
}

EstimatesTPIAnticipatedCost.propTypes = {
  estimate: PropTypes.shape({
    project_cost: PropTypes.number,
    project_cost_tax: PropTypes.number,
    projectCost: PropTypes.number,
    projectCostTax: PropTypes.number,
    construction_cost: PropTypes.number,
    constructionCost: PropTypes.number,
    local_region_area: PropTypes.number,
  }),
  project: PropTypes.shape({
    unit_of_measure: PropTypes.string,
  }),
  futureYear: PropTypes.number,
  inflation: PropTypes.number,
  containerType: PropTypes.string,
  descriptionType: PropTypes.string,
  isBreakdown: PropTypes.bool,
  isDisabled: PropTypes.bool,
};
